var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Страница не найдена.")]),_c('div',[_c('router-link',{staticClass:"link",attrs:{"to":{ name: 'home' }}},[_vm._v("Вернуться на главную")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }